export default {
  common: {
    currentLanguage: 'The current language is "{{lng}}"',
    email: 'Email',
    password: 'Password',
    edit: 'Edit',
    update: 'Update',
    cancel: 'Cancel',
    delete: 'Delete'
  },
  home: {
    logout: 'Logout'
  },
  auth: {
    notRegistered: 'Not registered?',
    forgotPassword: 'I lost my password',
    forgotPasswordContent: 'Enter your GOWOD email, a temporary password will be sent to you allowing you to sign in.\nDon\'t forget to change it then from the app settings.',
    localstorageError: 'It seems you blocked all cookies on your browser. This site uses them only to store authentication data, please allow cookies.',
    signIn: 'Sign in',
    modal: {
      title: 'Signing up to GOWOD is done from the mobile app',
      content: 'The application is available for iOS and Android'
    },
    signinFacebook: "Sign in with Facebook",
    signinGoogle: "Sign in with Google",
  },
  tabs: {
    profile: 'Profile',
    pdata: 'Personal data',
    premium: 'GOWOD Premium',
    gifts: 'Gift cards'
  },
  profile: {
    firstname: 'Firstname',
    lastname: 'Lastname',
    age: 'Age',
    sex: 'Sex',
    affiliate: 'Affiliate',
    country: 'Country',
    birthdate: 'Birthdate'
  },
  sex: {
    MALE: 'Male',
    FEMALE: 'Female',
    OTHER: 'Other'
  },
  pdata: {
    title: 'The personal data collected by GOWOD for its proper functioning are:',
    part1: 'Profile data: surname, first name, age, sex, affiliated box and country',
    part2: 'Mobility test results: answers, scores, configured profile',
    part3: 'The generated protocols for statistical use: date, selected duration, type (pre/post WOD, daily) and the selected movements',
    manage: 'DATA MANAGEMENT',
    download: 'Download my data',
    delete: 'Delete my account',
    deleteModal: {
      title: 'GOWOD account deletion',
        part1: 'Are you sure you want to delete your GOWOD account?',
        part2: 'This action is',
        part3: 'definitive and irreversible',
        part4: 'Note: if you are subscribed through iTunes, the deletion of your account WILL NOT UNSUBSCRIBE YOU.',
        part5: 'Follow this link to help you unsubscribe from iTunes'
    }
  },
  promoTuto: {
    line1: 'How to use your promocode « COMMUNITY »?',
    line2: '40 DAYS FREE TRIAL',
    step1: "Choose one of the offer below",
    step2: 'Click on subscribe',
    step3: 'Click on "I have a promocode" (only present if first signup)',
    step4: 'Enter your promocode: COMMUNITY',
    step51: 'Cancel anytime before the end of the trial',
    step52: 'to not be billed',
    step53: "if you don't want to continue",
    warning: "Attention: Offer valid only on your first signup"
  },
  premium: {
    authenticatePayment: "Authenticate payment",
    seeInvoice: "Solve the issue",
    premiumUnlocks: "GOWOD Premium gives you access to the monthly mobility test which allows you to determine the most important mobility aspect to improve for you, and to all the PRE-WOD POST-WOD and Daily protocols, configured on your weak point to improve your mobility efficiently.",
    premiumSlogan: "Mobility made easy and personalized",
    point1: 'Improve your WOD performance',
    point2: 'Facilitate the acquisition of an optimal technique',
    point3: 'Optimize the transfer of your strength',
    point4: 'Speed up your recovery',
    point5: 'Reduce your risk of injury',
    freeTrial: '14 days free trial for the first subscription',
    monthly: ' Monthly',
    halfYearly: 'Half-yearly',
    yearly: ' Yearly',
    subscribe: 'Subscribe',
    perMonth: '/ month',
    per6Months: '/ 6 months',
    perYear: '/ year',
    subscriptionFrom: 'Subscription from',
    pausedUntil: 'Subscription paused until',
    nextBilling: 'Next billing',
    changePlan: 'Change plan',
    confirm: 'Confirm',
    reactivateSub: 'Reactivate Subscription',
    unpauseSub: 'Unpause subscription',
    unpauseText: 'You are about to unpause your subscription, restart the GOWOD app once unpaused to resume access to GOWOD Premium.',
    unpause: 'Unpause',
    break: 'You can take a break instead!',
    pauseFor: 'Pause your account for:',
    oneMonth: '1 Month',
    twoMonths: '2 Months',
    threeMonths: '3 Months',
    pauseText: 'You will not be billed during your break, your GOWOD Premium subscription and access will resume at the end of this period. You can also unpause any time you want.',
    pauseSub: 'Pause my subscription',
    noThanks: 'No thanks, unsubscribe',
    month: 'month',
    promocode: 'Promo code',
    signupDate: 'Signup date',
    accessUntil: 'Access until',
    firstBilling: 'First billing',
    currentPeriod: 'Current period',
    status: 'Status',
    cancelAtEnd: 'Cancelled at the end of current period',
    changePlanTitle: "Change plan",
    changePlanContent: "If you are in a trial period, it will be preserved and your new plan will be billed at the end of the trial period.\nIf not, your subscription will change plan immediately and you will be billed a prorated amount for the new plan, taking into account the used portion of the old plan.",
    statuses: {
      active: 'Active',
      trialing: 'Trialing',
      past_due: 'Payment problem',
      unpaid: 'Payment problem',
      incomplete: 'Authentication needed',
    },
    updateCC: 'Update credit card',
    updateModal: {
      title: 'Credit card update',
      content: 'Please enter your new card information:'
    },
    unsubscribe: 'Unsubscribe',
    successModal: {
      title: "Subscription successful!",
      part1: "Congratulations, you are now a GOWOD Premium member!",
      part2: "Please close and reopen your GOWOD app so that your Premium access is taken into account."
    },
    unsubModal: {
      title: 'Confirm unsubscribe',
      part1: 'Would you take a moment to help us get better by telling us why you are leaving?',
      mail: 'If you have a problem you can send us an email directly to ',
      part2: 'You will have access to GOWOD Premium until the end of the last billed period.',
      confirm: 'Confirm',
      reason1: 'I don\'t use it enough',
      reason2: 'Too expensive',
      reason3: 'It\'s not efficient enough',
      reason4: 'Other',
      addon: 'Anything you want to share? (Optional)'
    },
    storesModal: {
      title: 'Unsubscribe from the stores',
      part1: 'It seems you subscribed to GOWOD Premium through one of the app stores.',
      part2: 'You can unsubscribe from the store app corresponding to your platform.',
      part3: 'Please follow these links if you need help managing your subscriptions:',
    },
    subscribeModal: {
      title: 'Subscription to GOWOD Premium',
      havePromocode: 'I have a promo code',
      validate: 'Validate',
      invalidCode: 'Invalid code',
      validCode1: 'Valid code',
      validCode2: 'days free trial',
    },
    promocodeModal: {
      link: "I have a promo code",
      title: "Use of a promotional code",
      intro: "Promotional codes allow you to extend the trial period of your GOWOD Premium subscription.",
      intro2: "They can only be used on your first subscribtion.",
      step1: "Choose the desired invoicing (monthly or semi-annual) and click on the corresponding button",
      step2: "The registration pop-up opens and if this is your first subscription, activate the promo code switch",
      step3: "Enter your code in the field, and validate it with the button",
      step4: "If your code is valid you will see a validation message confirming the duration of the trial period",
      step5: "You can now fill in your payment details and continue your registration"
    }
  },
  messages: {
    welcome: 'Welcome {{firstname}}',
    error: 'An error occured',
    updateOK: 'Updated successfully!',
    updateKO: 'An error occured while updating your profile',
    subscribeOK: 'Subscribed to GOWOD Premium successfully',
    subscribeKO: 'An error occured while subscribing',
    cardInvalid: 'Invalid card',
    cardUpdateOK: 'Card updated successfully',
    cardUpdateKO: 'An error occured while updating the card',
    cancelOK: 'Subscription cancelled successfully',
    cancelKO: 'An error occured while unsubscribing',
    premiumInfoKO: 'An error occured while fetching premium info',
    deleteKO: 'An error occured while fetching your personnal data',
    pdataKO: 'An error occured while deleting your account',
    pauseOK: 'Subscription paused',
    wrongCardData: 'Card data invalid',
    resetOK: 'Temporary password sent'
  },
  giftCards: {
    noiTunes: 'A gift card code is of the form XXXX-XXXX-XXXX, please note that if you are subscribed through iTunes or Google Play, the code will have no effect. <br/>To learn the procedure to switch from iTunes to our website, please send an email to <strong style="color:#6499FF">help@gowod.eu</strong>',
    enterCode: 'To use your gift card, please enter the code here:',
    successMessage: 'Your gift card has been redeemed! Restart the application and you should now have access to GOWOD Premium.',
    redeem: 'Redeem'
  }
}


// WEBPACK FOOTER //
// ./src/languages/en.js